import type { LucideIcon } from 'lucide-react'

import { LocationType } from '~/client/graph/types.generated'
import {
  getLocationIconComponent,
  LOCATION_ICON_BY_TYPE,
} from '~/client/src/shared/components/SitemapHelpers/utils/markerSpec'
type NonResourceLocationType = Exclude<
  LocationType,
  LocationType.Sensor | LocationType.Material | LocationType.Location
>

// Derived, not hand-listed: a type that shows one glyph on the map and another in setup is the
// failure both tables exist to prevent. The cast is sound because the source is total — a new
// LocationType cannot reach here undeclared, it fails typecheck in LOCATION_ICON_BY_TYPE first.
const locationTypeToTagIconMap = Object.fromEntries(
  Object.entries(LOCATION_ICON_BY_TYPE)
    .filter(([, icon]) => !!icon)
    .map(([type, icon]) => [type, getLocationIconComponent(icon)]),
) as Record<NonResourceLocationType, LucideIcon>

export default locationTypeToTagIconMap
